import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { semantic_colors, shapes } from '../../foundation';
import { TooltipSize, TooltipKind } from './types';
import { tooltip_size_css, tooltip_kind_color_css } from './styles';
export interface TooltipBaseProps {
  /** @default 'medium' */
  size?: TooltipSize;
  /** @default 'accent' */
  kind?: TooltipKind;
}

export const TooltipBase = styled.div<TooltipBaseProps>`
  ${shapes.border_radius.xsmall};
  max-width: 320px;
  word-break: break-all;
  color: ${semantic_colors.content.primary_inverse};
  ${({ size }) => tooltip_size_css[size ?? 'medium']};
  ${({ kind }) => {
    const main_color = tooltip_kind_color_css[kind ?? 'accent'];
    return css`
      background-color: ${main_color};
      .pds-tooltip__arrow {
        position: absolute;
        background-color: ${main_color};
        width: 6px;
        height: 6px;
        transform: rotate(45deg);
      }
    `;
  }}
`;
